// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"2b80abb4","652":"d3854a84","787":"7ef13d06"}[chunkId] + ".chunk.js";
};